import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ShipDate from './component';

const shipDate = {
  id: 'markAsShipped.columns.shipDate',
  defaultMessage: 'Ship Date',
};

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(shipDate);
};

export default {
  id: 'mark-as-shipped-ship-date',
  index: 5,
  isDragable: false,
  minWidth: 100,
  width: 125,
  nonsortable: true,
  getName: GetName,
  name: <FormattedMessage {...shipDate} />,
  render: (data) => {
    return <ShipDate fulfillmentPlanId={data.id} />;
  },
};
